import classNames from "classnames";
import { FC, ReactNode } from "react";
import styles from "./styles.module.scss";

type Props = {
  className?: string;
  children: ReactNode;
};

const FragmentsWrapper: FC<Props> = ({ children, className }) => {
  return (
    <div className={classNames(styles.fragmentsWrapper, className)}>
      <div className={styles.background} />
      <div className={classNames(styles.circle, styles.left)} />
      <div className={classNames(styles.circle, styles.right)} />
      {children}
    </div>
  );
};

export default FragmentsWrapper;
